var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.className},[_c('svg',{class:`svg-${_vm.icon}`},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',{attrs:{"xlink:href":_vm.path}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }